<script>
	import listBase from '@_system/components/base/list.vue'
	import detailIndex from './detail/index.vue'
	export default {
		extends: listBase,
		name: 'knowledgeIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<detail-index ref="detailIndex" row={this.currentrow} />,
			]			
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'knowledge',
				windowName: '知识库',
				currentrow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			alterInitList(){
				this.columns = [{
					field:'shopname',
					title:'店铺',
					visible:true
				},{
					field:'itemId',
					title:'产品ID',
					render:'$input',
					visible:true
				},{
					field:'itemTitle',
					title:'产品名称',
					render:'$input',
					visible:true
				},{
					field:'skuName',
					title:'sku名称',
					visible:true
				},{
					field:'createTime',
					title:'创建时间',
					visible:true,
					formatter:'date'
				}]
			},
			detail(e){
				this.currentrow = e
				this.$refs.detailIndex.modal_show()
			},
			// beforeRender(res) {
			// 	res.list.forEach((item) => {
			// 		if (item.logofile) {
			// 			item.logofile =
			// 				'<div class="flex" style="position:absolute;left:0;top:0;height:100%;width:100%;flex-direction:row;justify-content:center;"><img style="height:100%;box-shadow: 0px 0px 1px grey" src="' +
			// 				item.logofile[0].url + '" /></div>'
			// 		}
			// 		if (item.sealfile) {
			// 			item.sealfile =
			// 				'<div class="flex" style="position:absolute;left:0;top:0;height:100%;width:100%;flex-direction:row;justify-content:center;"><img style="height:100%;box-shadow: 0px 0px 1px grey" src="' +
			// 				item.sealfile[0].url + '" /></div>'
			// 		}
			// 	})
			// },

			show() {

			},
			hide() {

			},
		},
		components: {
			detailIndex
		}
	}
</script>